// React
import React, { useReducer } from "react";
import { Routes, Route } from "react-router-dom";

// Pages
import LoginPage from "./pages/loginPage/LoginPage";
import ProtectedRoute from "./ProtectedRoute";
import MasterPage from "./pages/MasterPage";
import ResetPasswordPage from "./pages/ResetPassword";
import Category from "./pages/Category";
import StateData from "./pages/StateData/StateData";
import UserManagement from "./pages/userManagement/UserManagement";
import Categorymain from "./pages/categorymain/Categorymain";
import Categorysub from "./pages/Categorysub";
import India from "./pages/india/India";
import AuditTrials from "./pages/AuditTrials/AuditTrials";

// Context
import AppContext from "./context/appContext";

// Redux
import { mainReducer } from "./redux/reducer/mainReducer";

// Config
import { initialAppState } from "./context/initialAppState";

const App: React.FC = () => {
  const [globalState, dispatch] = useReducer(mainReducer, initialAppState);

  return (
    <AppContext.Provider value={{ globalState, dispatch }}>
      {" "}
      <Routes>
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/master/*"
          element={<ProtectedRoute element={<MasterPage />} />}
        >
          <Route index element={<India />} />
          <Route path="India" element={<India />} />

          <Route path="category" element={<Category />}>
            <Route path="main" element={<Categorymain />} />
            <Route path="sub" element={<Categorysub />} />
          </Route>
          <Route path="StateDate" element={<StateData />} />
          <Route path="UserManagement" element={<UserManagement />} />
          <Route path="Audit" element={<AuditTrials />} />
        </Route>
      </Routes>
    </AppContext.Provider>
  );
};

export default App;
